import React, { useState } from "react";
import Input from "@/components/elements/input/Input";
import WatchThumbnailList from "@components/elements/posts/watch/WatchThumbnailList";
import { useTranslation } from "react-i18next";

const ProfileDetailsWatch = ({
  userId = "",
  showInput = false,
}: {
  userId?: string;
  showInput?: boolean;
}) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { t } = useTranslation();
  return (
    <>
      {showInput && (
        <Input
          placeholder={t("main.watchTabs.placeholder")}
          name="watch_keywords"
          onChange={(e) => setSearchQuery(e)}
          clearable
        />
      )}
      <WatchThumbnailList search={searchQuery} userId={userId} />
    </>
  );
};

export default ProfileDetailsWatch;
